import "./App.css";
import React, { Suspense, lazy } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import { HelmetProvider } from 'react-helmet-async';
import Root from "./components/root/Root";
import AdminRoutes from "./components/root/Admin";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import PublicRoute from "./components/auth/PublicRoute";

// Loading component
const PageLoader = () => (
  <div className="flex h-screen w-full items-center justify-center bg-skyline-bg">
    <div className="h-16 w-16 animate-spin rounded-full border-4 border-t-skyline-accent border-gray-300"></div>
  </div>
);

// Lazy Loaded Pages
const Home = lazy(() => import("./pages/home/Home"));
const About = lazy(() => import("./pages/about/About"));
const ContactUs = lazy(() => import("./pages/contact us/ContactUs"));
const Login = lazy(() => import("./components/loginpage/Login"));
const OurStrength = lazy(() => import("./components/ourStrength/OurStrength"));
const OurEmployes = lazy(() => import("./components/ourEmployes/OurEmployes"));
const Completed = lazy(() => import("./components/projects/Completed"));
const OnGoing = lazy(() => import("./components/projects/OnGoing"));
const Gallery = lazy(() => import("./components/footer/Gallery"));
const Career = lazy(() => import("./pages/career/Career"));
const Keyperson = lazy(() => import("./components/Navbar/managment/keyperson/Keyperson"));
const AboutCompany = lazy(() => import("./components/Navbar/managment/keyperson/AboutCompany"));

// Admin Lazy Loaded Pages
const Assets = lazy(() => import("./components/assets/Assets"));
const Projects = lazy(() => import("./components/project/Project"));
const AddGallery = lazy(() => import("./components/AddGallery/AddGallery"));

function App() {
  const [theme, colorMode] = useMode();

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route path="/login" element={<PublicRoute><Suspense fallback={<PageLoader />}><Login /></Suspense></PublicRoute>} />
        
        <Route element={<ProtectedRoute><AdminRoutes /></ProtectedRoute>}>
          <Route path="/Employes" element={<Suspense fallback={<PageLoader />}><Completed /></Suspense>} />
          <Route path="/admin" element={<Suspense fallback={<PageLoader />}><OnGoing /></Suspense>} />
          <Route path="/assets" element={<Suspense fallback={<PageLoader />}><Assets /></Suspense>} />
          <Route path="/projects" element={<Suspense fallback={<PageLoader />}><Projects /></Suspense>} />
          <Route path="/AddGallery" element={<Suspense fallback={<PageLoader />}><AddGallery /></Suspense>} />
        </Route>
        
        <Route element={<Root />}>
          <Route path="/" element={<Suspense fallback={<PageLoader />}><Home /></Suspense>} />
          <Route path="/about" element={<Suspense fallback={<PageLoader />}><About /></Suspense>} />
          <Route path="/contact" element={<Suspense fallback={<PageLoader />}><ContactUs /></Suspense>} />
          <Route path="/OurStrength" element={<Suspense fallback={<PageLoader />}><OurStrength /></Suspense>} />
          <Route path="/OurEmployes" element={<Suspense fallback={<PageLoader />}><OurEmployes /></Suspense>} />
          <Route path="/completed" element={<Suspense fallback={<PageLoader />}><Completed /></Suspense>} />
          <Route path="/OnGoing" element={<Suspense fallback={<PageLoader />}><OnGoing /></Suspense>} />
          <Route path="/keyperson" element={<Suspense fallback={<PageLoader />}><Keyperson /></Suspense>} />
          <Route path="/PrevGallery" element={<Suspense fallback={<PageLoader />}><Gallery /></Suspense>} />
          <Route path="/career" element={<Suspense fallback={<PageLoader />}><Career /></Suspense>} />
          <Route path="/AboutCompany" element={<Suspense fallback={<PageLoader />}><AboutCompany /></Suspense>} />
        </Route>
      </Route>
    )
  );

  return (
    <HelmetProvider>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </ThemeProvider>
      </ColorModeContext.Provider>
    </HelmetProvider>
  );
}

export default App;
